<div class="w-full" [formGroup]="formGroup()">
  <div class="flex flex-col w-full">
<!--   Owner info -->
    <div class="flex flex-row items-center gap-8 mb-4">
        <p-floatlabel variant="in">
            <p-select class="w-64" formControlName="idType" id="id-type-select" optionLabel="name" optionValue="id" required="true" [options]="idTypeList">
                <ng-template #selectedItem let-selectedOption>
                    @if (formGroup().get('idType')?.value) {
                        <div class="flex items-center gap-2">
                            {{ selectedOption.name | translate}}
                        </div>
                    }
                </ng-template>
                <ng-template #item let-idTypeOption>
                    <div class="flex items-center gap-2">
                        {{ idTypeOption.name | translate}}
                    </div>
                </ng-template>
            </p-select>
            <label for="id-type-select">{{ "chipRegistration.owner.idTypeLabel" | translate }}*</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
            @if (isOwnerSearchAvailable()) {
                <button
                    class="absolute top-1/2 right-2 -translate-y-1/2 text-gray-500 cursor-pointer disabled:opacity-50"
                    type="button"
                    [disabled]="formGroup().get('idNumber')?.value?.length === 0"
                    (click)="searchForOwner.emit()">
                    <svg class="size-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            }
            <input class="w-64" formControlName="idNumber" id="idNumber" pInputText required="true" type="text" />
            <label for="idNumber">{{ 'chipRegistration.owner.idNumberLabel' | translate }}*</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
            <input class="w-64" formControlName="nameSurname" id="nameSurname" pInputText required="true" type="text" />
            <label for="nameSurname">{{ 'chipRegistration.owner.nameSurnameLabel' | translate }}*</label>
        </p-floatlabel>
    </div>

    <div class="flex flex-row items-center gap-8 mb-4">
        <p-floatlabel variant="in">
            <input class="w-64" formControlName="phone" id="phone" pInputText required="true" type="text" />
            <label for="phone">{{ 'chipRegistration.owner.phone' | translate }}*</label>
        </p-floatlabel>
        <p-floatlabel variant="in">
            <input class="w-64" formControlName="email" id="email" pInputText required="true" type="text" />
            <label for="email">{{ 'chipRegistration.owner.email' | translate }}*</label>
        </p-floatlabel>
    </div>

<!-- Owner adress   -->
    <div class="flex flex-row items-center gap-8 mb-4">
        <p-floatlabel variant="in">
            <p-select class="w-64" formControlName="countryId" id="owner-country-id" optionLabel="name" optionValue="id" [options]="countries"(onChange)="changeCountry($event)" />
            <label for="owner-country-id">{{ "chipRegistration.owner.countryLabel" | translate }}</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
            <p-select class="w-64" formControlName="regionId" id="owner-region-id" optionLabel="name" optionValue="id" [options]="regions" (onChange)="changeRegion($event)" />
            <label for="owner-region-id">{{ "chipRegistration.owner.regionLabel" | translate }}</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
            <p-select class="w-64" formControlName="settlementId" id="owner-settlement-id" optionLabel="name" optionValue="id" [options]="settlements" />
            <label for="owner-settlement-id">{{ "chipRegistration.owner.settlementLabel" | translate }}</label>
        </p-floatlabel>
    </div>

    <div class="flex flex-row items-center gap-8">
        <p-floatlabel variant="in">
            <input class="w-64" formControlName="address" id="address-owner" pInputText required="true" type="text" />
            <label for="address-owner">{{ 'chipRegistration.owner.address' | translate }}*</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
            <input class="w-64" formControlName="zipCode" id="zipCode-owner" pInputText required="true" type="text" />
            <label for="zipCode-owner">{{ 'chipRegistration.owner.zipCode' | translate }}*</label>
        </p-floatlabel>
    </div>

    @if (formGroup().get('isAddressSameAsOwner')) {
        <div class="flex flex-row items-center gap-2 mt-4">
            <p-checkbox formControlName="isAddressSameAsOwner" inputId="isAddressSameAsOwner-owner" [binary]="true" [required]="true" />
            <label for="isAddressSameAsOwner-owner">{{ "chipRegistration.animal.addressAsOwner" | translate }}*</label>
        </div>
    }
  </div>
</div>

